export const languageStringsPopups = {
  deletionWasSuccessful: "Deletion was successful.",
  saveWasSuccessful: "Successfully saved.",
  visualChanged: "Visual settings were applied successfully.",
  notificationAdded: "Notification has been added.",
  setButtonText: "Set the button text.",
  missingHttp: 'The URL must start with "http" or "https".',
  addNameAndText: "Please add a notification name and text.",
  textMustBeFilled: "Notification text must be filled in.",
  connectionMissing: 'At least one condition must be fulfilled in "Pairing".',
  added: "Added.",
  fillAllFields: "Please fill in all fields.",
  fillApiKey: "Please enter the API key.",
  webCreatedSuccessfully: "Website was created successfully.",
  notVerified: "Not verified",
  changesSaved: "Changes saved successfully.",
  changeSubscriptionDisabled: "Changing the subscription is disabled.",
  subscriptionChangedTo: "Subscription changed to:",
  subscriptionCanceled: "Subscription successfully canceled.",
  nameIsEmpty: "Name cannot be empty.",
  cannotCreateNotification: "Failed to create notification.",
  fillApiAndPlaceId: "Enter the API key and Place ID.",
  verificationFailed: "Verification failed.",
  apiKeyVerificatedSuccess: "API key was successfully verified.",
  fillApiAndBusinessUnitId: "Enter the API key and Business Unit ID.",
  googleReviewsWasVerified: "Google Reviews was successfully verified.",
};
